module.exports = __webpack_public_path__ + "img/headimage.0951c95.png";